// extracted by mini-css-extract-plugin
export default {"Badge":"HelperTooltip_Badge__vofj0","Wrapper":"HelperTooltip_Wrapper__imnLt"};